export default class CookiePreferencesToggle extends HTMLElement {
  constructor() {
    super();
  }

  get button() {
    return this.querySelector("button");
  }

  get callbackSupported() {
    // callback requires global object `privacyBanner` on window
    // set by Shopify when cookie banner is enabled in Admin
    return (
      typeof privacyBanner === "object" &&
      typeof privacyBanner.showPreferences === "function"
    );
  }

  get shouldShowToggle() {
    // check if customer is in a region with the banner enabled first
    const shouldShowBanner = Shopify.customerPrivacy?.shouldShowBanner();

    if (!shouldShowBanner) return false;

    // confirm that callback will work before showing toggle
    return this.callbackSupported;
  }

  connectedCallback() {
    Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      (error) => {
        if (error) {
          console.error(error);
          return;
        }
        // customerPrivacy API is now loaded

        const shouldShowBanner = Shopify.customerPrivacy?.shouldShowBanner();

        if (!shouldShowBanner || !this.callbackSupported) {
          this.button?.setAttribute("hidden", "");
          return;
        }

        this.button?.addEventListener("click", this.handleClick);
      },
    );
  }

  disconnectedCallback() {
    const shouldShowBanner = Shopify.customerPrivacy?.shouldShowBanner();

    if (!shouldShowBanner || !this.callbackSupported) return;

    this.button?.removeEventListener("click", this.handleClick);
  }

  handleClick = async () => {
    await privacyBanner.showPreferences();
  };
}
